module.exports = require("./lg");